import * as React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Spinner from './Spinner';

interface IProps {
  fullscreen: boolean;
  label: string;
}

const useStyles = createUseStyles({
  root: {
    padding: 0,
    margin: 0,
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    zIndex: 100,
    height: '100%',
    width: '100%',
    backgroundColor: 'white',
    opacity: 0.4,
    '& img': {
      height: '200px',
      width: '200px',
      borderRadius: '5px',
    },
  },
  content: {
    margin: 'auto',
    textAlign: 'center',
  },
  displayFullScreen: {
    position: 'fixed',
  },
});

const SpinnerWithText = ({ fullscreen, label }: IProps) => {
  const { root, content, displayFullScreen } = useStyles();

  return (
    <div className={classNames(root, { [displayFullScreen]: fullscreen })}>
      <div className={content}>
        <Spinner />
        <p>{label}</p>
      </div>
    </div>
  );
};

export default SpinnerWithText;
